import { FC, useState } from "react";
import images from "../../assets/images";
import './MeetSidebar.scss';

import { useGlobalState } from "../../MeetContext/MeetContext";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";
import {  useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import { useAppSelector } from "../../redux/app/hooks";
import { CHIME, JITSI } from "../../utils/constants";
import { useDispatch } from "react-redux";
import { setChatIndication } from "../../redux/slices/JitsiMeetSlice";


const MeetSidebar: FC = () => {
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const { chatActive, ChatInactive, ParticipantsInactive, GroupsInactive,participantsActive, groupActive, ShareGif } = images;
    const { isChatOpen, toggleChat, meetStateRef, toggleParticipant, isParticipantListView, isParticipantsGridViewVisible, handleParticipantsGridViewToggle, stopScreenShare } = useGlobalState();
    const {readCount, showChat, hasNewChatMessages, setHasNewChatMessages} = useChimeMeeting();
    const { apiRef, activePanel, chatIndication, isMeetjoined, jitsiHostId } = useAppSelector((state) => state.JitsiMeetSlice);
    const { meetService, meetServiceOrganization, role, loginpage } = useAppSelector((state) => state.auth);
    const meetingService = meetService;

    const dispatch = useDispatch();
    // const unreadMessagesCount = chatMessages ? Object.keys(chatMessages).filter((key) => chatMessages[key].read === false).length: 0;
    console.log("[Log]", { jitsiHostId, apiRef });
    
    const handleClickChat = () => {
        console.log("[Log]", { apiRef, isMeetjoined });
        if (meetService === JITSI) {
            if (apiRef) {
                if (activePanel === "tileView") {
                    if (jitsiHostId) {
                        apiRef.setLargeVideoParticipant(jitsiHostId);
                    } else {
                        apiRef.executeCommand("toggleTileView");
                    }
                }
                if (activePanel === "participants") {
                    apiRef.executeCommand("toggleParticipantsPane", false);
                }
                apiRef.executeCommand("toggleChat");
                dispatch(setChatIndication({ chatIndication: false }));
              }
        }
        else {
            if(isParticipantListView){
                toggleParticipant(!isParticipantListView);
            }
            toggleChat(!isChatOpen);
            if (hasNewChatMessages) setHasNewChatMessages(false);
            handleParticipantsGridViewToggle(false);
        }
    }

    const handleClickParticipant = () => {
        console.log("[Log]", { apiRef });
        if (meetService === JITSI) {
            if (apiRef) {
                if (jitsiHostId) {
                    apiRef.setLargeVideoParticipant(jitsiHostId);
                } else {
                    apiRef.executeCommand("toggleTileView");
                }
                if (activePanel === "chat") {
                  apiRef.executeCommand("toggleChat");
                }
                if (activePanel === "participants") {
                    apiRef.executeCommand("toggleParticipantsPane", false);
                }
                else {
                    apiRef.executeCommand("toggleParticipantsPane", true);
                }
            }
        }
        else {
            if(isChatOpen){
                toggleChat(!isChatOpen);
                if (hasNewChatMessages) setHasNewChatMessages(false);
            }
            toggleParticipant(!isParticipantListView);
            handleParticipantsGridViewToggle(false);
        }
    }

    const handleGroupClick = () => {
        console.log("[Log]", { apiRef });
        if (meetService === JITSI) {
            if (apiRef) {
                if (activePanel === "chat") {
                  apiRef.executeCommand("toggleChat");
                }
                if (activePanel === "participants") {
                    apiRef.executeCommand("toggleParticipantsPane", false);
                }
                if (jitsiHostId && activePanel === "tileView") {
                    apiRef.setLargeVideoParticipant(jitsiHostId);
                } else {
                    apiRef.executeCommand("toggleTileView");
                }
            }
        }
        else {
            if (meetStateRef?.current?.currentUser?.preference?.screen) {
                setOpenConfirmationPopup(true);
            } else {
                toggleChat(false);
                if (hasNewChatMessages) setHasNewChatMessages(false);
                toggleParticipant(false);
                handleParticipantsGridViewToggle(!isParticipantsGridViewVisible)
            }
        }
    }
    
    return (
        <>
        <div className='meetSidebarMainContainer'>
            <div className='meetTitleContainer'>
                <div className='katonTitle'>KATON</div>
                <div className='liveMeetTitle'>LIVE MEET</div>
            </div>
            <div className={`meetIconsContainer ${ (!isMeetjoined && meetService === JITSI) ? "disable" : "" }`}>
                <div className='participants' onClick={handleClickParticipant}>
                    <img src={ (isParticipantListView || activePanel === "participants") ? participantsActive : ParticipantsInactive } className='participantsIcon' alt="participant active"/>
                </div>
                {((showChat && (meetService === CHIME)) || meetService === JITSI) && <div className='chat' onClick={handleClickChat}>
                    <div className='chatIconContainer'>
                        <img src={ (isChatOpen || activePanel === "chat") ? chatActive : ChatInactive } className='chat active' alt="chatActiveIcon"/>
                        {/* {(!isChatOpen && unreadMessagesCount > 0) && <span className='unreadDot'></span>} */}
                        {(chatIndication || (!isChatOpen && hasNewChatMessages)) && <span className='unreadDot'></span>}
                    </div>
                </div>}
                <div className="group" onClick={handleGroupClick}>
                    <img
                        src={(isParticipantsGridViewVisible || activePanel === "tileView") ? groupActive : GroupsInactive}
                        className="groupIcon"
                        alt="Group Icon"
                    />
                </div>
            </div>
        </div>
        <ConfirmationPopup
            open={openConfirmationPopup}
            message={`Are you sure you want to end the screen share?`}
            gifData={ShareGif}
            yesButtonFunctionality={() => {
                stopScreenShare();
                toggleChat(false);
                toggleParticipant(false);
                handleParticipantsGridViewToggle(true);
                setOpenConfirmationPopup(false);
            }}
            noButtonFunctionality={() => {setOpenConfirmationPopup(false)}}
            messageWidth={'221px'}
        />
        </>
    );
}

export default MeetSidebar;
